const en = {
  translation: {
    'navigation-about': 'About',
    'navigation-alphabet': 'Alphabet',
    'navigation-apps': 'Mobile App',
    'navigation-categories': 'Categories',
    'navigation-dictionary': 'Dictionary',
    'navigation-games': 'Games',
    'navigation-kids': 'Kids',
    'navigation-keyboards': 'Keyboards',
    'navigation-learn': 'Learn',
    'navigation-our-language': 'Our Language',
    'navigation-our-people': 'Our People',
    'navigation-phrases': 'Phrases',
    'navigation-resources': 'Resources',
    'navigation-songs': 'Songs',
    'navigation-stories': 'Stories',
    'navigation-words': 'Words',
    'role-language_admin': 'Language Admin',
    'role-editor': 'Editor',
    'role-assistant': 'Assistant',
    'role-member': 'Member',
  },
}

export default en
